import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

import { SAM } from './base/sam';
import { SAMMessage } from './interfaces/sam-message';
import { SAMRouter } from './base/sam-router';
import { GUIHelperService } from '../gui-helper.service';

@Injectable({
  providedIn: 'root'
})
export class SAMService extends SAM {

  router: SAMRouter = new SAMRouter(this);

  channels = {
    audio: new Subject(),
    auth: new Subject(),
    cart: new Subject(),
    gui: new Subject(),
    menus: new Subject(),
    dialogs: new Subject(),
    jhim: new Subject(),
    network: new Subject(),
    restaurant: new Subject(),
    sale: new Subject(),
    xact: new Subject(),
  };

  messagesSub: Subscription = null;

  constructor(
    public guiHelperSvc: GUIHelperService
  ) {
    super(guiHelperSvc);
  }

  subscribeListeners() {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe();
    }
    this.messagesSub = this.messages.subscribe((message: SAMMessage) => {
      this.router.dispatch(message);
    });
  }
}
